import PropTypes from 'prop-types'
import React from 'react'

import styles from './marketplaceStats.module.css'

import { commaStyleString } from '../../../../common/utils/formatString'

class MarketplaceStats extends React.Component {
  static propTypes = {
    stats: PropTypes.object
  }

  render() {
    let { stats } = this.props
    return (
      <ul className={styles.list}>
        {stats &&
          stats.total_items_sold &&
          stats.total_items_sold.toString() && (
            <li className={styles.listItem}>
              <span className={styles.stats}>
                {`${commaStyleString(stats.total_items_sold)} `}
              </span>
              items sold
            </li>
          )}
        {stats &&
          stats.total_community_earnings &&
          stats.total_community_earnings.toString() && (
            <li className={styles.listItem}>
              <span className={styles.stats}>
                {`$${commaStyleString(
                  Math.round(stats.total_community_earnings)
                )} `}
              </span>
              community earnings
            </li>
          )}
      </ul>
    )
  }
}

export default MarketplaceStats
